/**
 * TEMP: Bridge feature allowlist for mix export.
 * Only these user IDs can see/use the export action.
 */
const MIX_EXPORT_ALLOWLIST = new Set<string>([
  '21ooyaldsh3fso4sdrkef5byi',
  '31ozx2p3wpr4nd25gfuquf5pt2ii',
  '1257764249'
]);

export const isMixExportAllowedUser = (userId: string | null | undefined): boolean => {
  if (!userId) return false;
  const trimmed = userId.trim();
  if (!trimmed) return false;
  return MIX_EXPORT_ALLOWLIST.has(trimmed);
};
